module.exports = __webpack_public_path__ + "static/image1-2f6bafaf23bbbfd8237030772af3f601.png";